/**
****************************************************************************************
Project: Readabl
File: RenderImage.js
Description: This component will render the converted pdf images. This SelectionLayer, RenderRectangle, 
and DisabledLayer component are child for this component   
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React, { useEffect, useState } from "react";
import { DisabledLayer, RenderRectangle, SelectionLayer, RotateLayer } from ".";

const RenderImage = (props) => {
    const [imageList, updateImageList] = useState([]);

    useEffect(() => {
        updateImageList(props.images)
    }, [props.images]);

    const getDynamicDimensions = (angle = 0) => {
        const normalized = angle % 360;
        if (normalized === 90 || normalized === 270) {
          return {
            width: props.imageDimensions.height,
            height: props.imageDimensions.width
          };
        }
        return {
          width: props.imageDimensions.width,
          height: props.imageDimensions.height
        };
      };



    return <>
        {(imageList || []).map((obj, i) => <div className="pdf-viewer-item"
            style={{
                ...getDynamicDimensions(props.rotatedPages?.[obj.page] || 360),
                transform: `rotate(${props.rotatedPages?.[obj.page] || 360}deg) ${props.rotatedPages?.[obj.page] == 90 ? "translateY(-30%)" : ""}`,
                // boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.2)",
            }}>
            <img
                className="pdf-viewer-item-image"
                key={i}
                src={obj.url}
                width={props?.imageDimensions?.width}
                height={props.imageDimensions?.height}
            />
            {props.highlightCoordinates.filter(m => m.page == obj.page)?.length ? <svg key="highlight" id="pdf-viewer-highlight-container" className="pdf-viewer-highlight-container" width={props?.imageDimensions?.width} height={props.imageDimensions?.height}>
                <RenderRectangle
                    coordinates={props.highlightCoordinates.filter(m => m.page == obj.page) || []}
                    key={i}
                    imageDimensions={props.imageDimensions}
                    highlight={true}
                    id={"pdf-highlight-id-" + obj.page}

                />
            </svg> : null}
            <DisabledLayer
                {...obj}
                disabled={props.disabledPages?.includes(obj.page)}
                imageDimensions={props.imageDimensions}
                // disabledText={props.disabledText}
            />
            <SelectionLayer
                {...obj}
                key={i + 1}
                rotateAngle={props.rotatedPages?.[obj.page] || 360}
                disabled={props.disabledPages?.includes(obj.page)}
                selectionEnabled={props.selectionEnabled}
                imageDimensions={props.imageDimensions}
                selectedPages={props.selectedPages}
                handleSelection={props.handleSelection}
            />
        </div>
        )}
    </>
}

export default RenderImage;